<template>
  <div class="rwd-padding">
    <div
      class="text-center bg-tranparent-yellow pa-3 text-title font-weight-bold "
    >
      <slot name="title" />
    </div>
    <v-divider class="my-0 mt-2 " />
    <div
      v-if="couldCulturePoint && $route.name === 'Order2'"
      class="art-coupon-container"
      :class="{
        'is-disabled': !!reserveResponse.culturePointDeductAmount
      }"
    >
      <v-checkbox
        v-model="culturePointUsage"
        color="teal teal-darken-1"
        :label="``"
        @change="updateCulturePointUsage"
        :checked="culturePointUsage"
      >
        <template slot="label"
          ><span v-html="$t('culturepoint_discount')"></span
        ></template>
      </v-checkbox>
    </div>
    <v-row class=" py-3 font-weight-bold text-nine" no-gutters>
      <v-col
        v-for="(head, i) in thead"
        :key="`table-head-${i + 1}`"
        :class="head.class + ` ${head.colSm ? 'mb-2' : ''}`"
        :cols="head.colSm ? head.col : 6"
        :sm="head.colSm || head.col"
      >
        {{ head.label }}
      </v-col>
    </v-row>
    <v-divider class="my-0 " />
    <div v-for="(ticket, i) in tickets" :key="i">
      <v-row class="py-2 py-md-3" no-gutters>
        <v-col
          v-for="(head, j) in thead"
          :key="`table-body-${i}-${j}`"
          :cols="head.colSm ? head.col : 6"
          :sm="head.colSm || head.col"
          :class="
            head.class +
              ` ${head.colSm && !$vuetify.breakpoint.xs ? 'my-2' : ''}`
          "
        >
          <template v-if="head.name === 'seat'">
            <template v-if="!!ticket.seat">
              {{ ticket.seat }}
            </template>
            <template v-else>
              {{
                ticket.seat || (!!ticket.row && ticket.column)
                  ? `${
                      ticket.row.indexOf("虛擬排") === -1
                        ? `${ticket.row}
              ${$t("seat_row")}`
                        : ""
                    } ${ticket.column} ${$t("seat_column")}`
                  : "-"
              }}
            </template>
          </template>
          <template v-else-if="head.name === 'sum'">
            NT.
            {{
              (ticket.count * ticket.price)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }}
            <template
              v-if="
                couldCulturePoint &&
                  useCulturePoint &&
                  ticket.culturePointProductInfos &&
                  !areaAssignment
              "
            >
              <div
                v-if="!!ticket.culturePointProductInfos.deductAmount"
                class="primary-1--text mt-3"
                :class="!$vuetify.breakpoint.xs ? 'text-title' : ''"
              >
                <b> -NT. {{ ticket.culturePointProductInfos.deductAmount }}</b>
              </div>
              <div
                v-else
                class="primary-1--text mt-3"
                :class="!$vuetify.breakpoint.xs ? 'text-title' : ''"
              >
                <b>
                  -NT.
                  {{
                    ticket.culturePointProductInfos.reduce(
                      (accr, info) => (accr += info.deductAmount),
                      0
                    )
                  }}</b
                >
              </div>
            </template>
          </template>
          <template v-else-if="head.name === 'price'">
            NT.
            {{
              (ticket.price || 0)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }}
            <template
              v-if="
                couldCulturePoint &&
                  useCulturePoint &&
                  ticket.culturePointProductInfos &&
                  areaAssignment
              "
            >
              <div class="primary-1--text mt-2">
                <!-- * {{ $t('orderlist_culturepoint') }}  -->
                <b>-NT. {{ ticket.culturePointProductInfos.deductAmount }}</b>
              </div>
            </template>
          </template>
          <template v-else>
            {{ ticket[head.name] }}
          </template>
        </v-col>
      </v-row>
      <v-divider class="my-0 " v-if="i !== tickets.length - 1" />
    </div>
    <v-divider class="" />
    <div
      v-if="$route.name !== 'ConfirmSt'"
      class="grey lighten-2 px-md-3"
      :class="
        ['Order3', 'Order2', 'OrderedPayment'].includes($route.name)
          ? 'py-md-4'
          : 'py-md-1'
      "
    >
      <v-row class=" pt-2 pt-sm-4 pt-md-0 pb-3 pb-md-0" no-gutters>
        <v-col
          cols="9"
          sm="9"
          class="d-flex font-weight-bold align-center"
          :class="
            $vuetify.breakpoint.xs
              ? 'text-small pl-4'
              : 'text-right ml-8 text-title justify-end'
          "
        >
          <span
            class="mr-2 font-weight-bold"
            v-html="$t('ticket_table_total_count', { amount: amount })"
          ></span>
          {{
            $t(
              `tickets_summary${
                $route.name !== "OrderedPayment" && campaign.isLottery
                  ? "_lottery"
                  : ""
              }`
            )
          }}
        </v-col>
        <v-col
          cols="3"
          sm="2"
          class="d-flex align-center justify-end"
          :class="
            $vuetify.breakpoint.xs
              ? 'text-small text-right pr-4'
              : `text-center text-title`
          "
        >
          <div>
            NT. {{ subTotal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}
          </div>
        </v-col>
      </v-row>
      <v-row
        class="pb-2 pb-sm-3 pb-md-0 pt-3 pt-md-4"
        no-gutters
        v-if="useCulturePoint && reserveResponse.culturePointDeductAmount > 0"
      >
        <v-col
          cols="9"
          sm="9"
          class="d-flex font-weight-bold align-center"
          :class="
            $vuetify.breakpoint.xs
              ? 'text-small pl-4'
              : 'text-right ml-8 justify-end text-title'
          "
        >
          {{ $t("orderlist_culturepoint_discount") }}
        </v-col>
        <v-col
          cols="3"
          sm="2"
          class="d-flex align-center justify-end"
          :class="
            $vuetify.breakpoint.xs
              ? 'text-small text-right pr-4'
              : 'text-center text-title'
          "
        >
          <div>-NT. {{ reserveResponse.culturePointDeductAmount }}</div>
        </v-col>
      </v-row>
      <template v-if="$route.name == 'Order3'">
        <v-row class="py-2 pb-md-0 tb-summary" no-gutters>
          <!-- <v-spacer /> -->
          <v-col
            cols="9"
            sm="9"
            class="d-flex font-weight-bold align-center"
            :class="
              $vuetify.breakpoint.xs
                ? 'pl-4 text-small'
                : 'text-right ml-8 justify-end text-title'
            "
          >
            {{ $t("orderlist_discount") }}
          </v-col>
          <v-col
            cols="3"
            sm="2"
            class="d-flex align-center justify-end"
            :class="
              $vuetify.breakpoint.xs
                ? 'text-right pr-4'
                : 'text-right text-title'
            "
          >
            <div v-if="discount" class="primary-1--text">NT.{{ discount }}</div>
            <template v-else>-</template>
          </v-col>
          <v-spacer />
          <v-col
            cols="9"
            sm="9"
            class="d-flex font-weight-bold align-center"
            :class="
              $vuetify.breakpoint.xs
                ? 'pl-4 text-small'
                : 'text-right ml-8 justify-end text-title pt-4'
            "
          >
            {{ $t("ticket_table_post_fee") }}
          </v-col>
          <v-col
            cols="3"
            sm="2"
            class="d-flex align-center justify-end"
            :class="
              $vuetify.breakpoint.xs
                ? 'text-right pr-4'
                : 'text-right text-title pt-4'
            "
          >
            <div v-if="isShippingFee" class="primary-1--text">
              NT.{{ shippingFee }}
            </div>
            <template v-else>-</template>
          </v-col>
          <v-spacer />
          <template
            v-if="
              (order && order.isWelfareFeeOrder) ||
                reserveResponse.welfareFee ||
                updateResponse.welfareFee
            "
          >
            <v-col
              cols="9"
              sm="9"
              class="d-flex font-weight-bold align-center"
              :class="
                $vuetify.breakpoint.xs
                  ? 'pl-4 text-small'
                  : 'text-right ml-8 justify-end text-title pt-4'
              "
            >
              {{ $t("ticket_table_welfare_fee") }}
            </v-col>
            <v-col
              cols="3"
              sm="2"
              class="d-flex align-center justify-end"
              :class="
                $vuetify.breakpoint.xs
                  ? 'text-right pr-4'
                  : 'text-right text-title pt-4'
              "
            >
              <div class="primary-1--text">
                NT.{{
                  reserveResponse.welfareFee ||
                    updateResponse.welfareFee ||
                    order.welfareFee
                }}
              </div>
            </v-col>
          </template>
        </v-row>
      </template>

      <template
        v-if="
          $route.name == 'OrderedPayment' &&
            (order.isWelfareFeeOrder ||
              reserveResponse.welfareFee ||
              updateResponse.welfareFee)
        "
      >
        <v-row class="py-2 pb-md-0 tb-summary" no-gutters>
          <v-col
            cols="9"
            sm="9"
            class="d-flex font-weight-bold align-center"
            :class="
              $vuetify.breakpoint.xs
                ? 'pl-4 text-small'
                : 'text-right ml-8 justify-end text-title pb-4'
            "
          >
            {{ $t("ticket_table_welfare_fee") }}
          </v-col>
          <v-col
            cols="3"
            sm="2"
            class="d-flex align-center justify-end"
            :class="
              $vuetify.breakpoint.xs
                ? 'text-right pr-4'
                : 'text-right text-title pb-4'
            "
          >
            <div class="primary-1--text">
              NT.{{
                reserveResponse.welfareFee ||
                  updateResponse.welfareFee ||
                  order.welfareFee
              }}
            </div>
          </v-col>
        </v-row>
      </template>
      <v-divider
        :class="
          $vuetify.breakpoint.xs || $vuetify.breakpoint.sm
            ? ''
            : `my-${$route.name === 'OrderedPayment' ? 1 : 4}`
        "
      />
      <v-row class="py-2 py-sm-4 py-md-0 tb-summary" no-gutters>
        <!-- <v-spacer /> -->
        <v-col
          cols="9"
          sm="9"
          class="d-flex font-weight-bold align-center"
          :class="
            $vuetify.breakpoint.xs
              ? 'pl-4 text-small'
              : 'text-right ml-8 justify-end text-title'
          "
        >
          {{ $t("orderlist_total") }}
        </v-col>
        <v-col
          cols="3"
          sm="2"
          class="d-flex align-center justify-end"
          :class="
            $vuetify.breakpoint.xs ? 'text-right pr-4' : 'text-right text-title'
          "
        >
          <div class="primary-1--text">
            NT.
            {{
              ($route.name === "Order3"
                ? total
                : total +
                  (updateResponse.discountAmount ||
                    reserveResponse.discountAmount ||
                    0) +
                  (-updateResponse.welfareFee ||
                    -reserveResponse.welfareFee ||
                    0)
              )
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }}
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  props: {
    thead: {
      type: Array,
      default: []
    },
    tickets: {
      type: Array,
      default: () => []
    },
    order: {
      type: Object,
      default: null
    },
    discount: {
      type: Number,
      default: 0
    },
    shippingFee: {
      type: Number,
      default: 0
    },
    isShippingFee: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      campaign: "event/campaign",
      areaAssignment: "order/areaAssignment",
      seatAssignment: "order/seatAssignment",
      reserveResponse: "order/reserveResponse",
      updateResponse: "order/updateResponse",
      couldCulturePoint: "culturePoint/couldCulturePoint",
      useCulturePoint: "culturePoint/useCulturePoint"
    }),
    culturePointTickets() {
      return [
        {
          couponIds: ["20211004223010214611"],
          deductAmount: 100,
          seqNo: "0000018893T00001",
          ticketAmount: 200
        }
      ];
    },
    amount() {
      if (!this.tickets || !this.tickets.length) return 0;
      if (!this.tickets[0].area) {
        return this.tickets.reduce((a, t) => a + t.count, 0);
      } else {
        return this.tickets.length;
      }
    },
    subTotal() {
      if (!this.tickets || !this.tickets.length) return 0;
      if (!this.tickets[0].area) {
        return this.tickets.reduce(
          (acc, { count, price }) => acc + count * Number(price),
          0
        );
      } else {
        return this.tickets.reduce(
          (acc, { count, price }) => acc + Number(price),
          0
        );
      }
    },
    total() {
      return (
        (this.reserveResponse?.total || this.order?.total || 0) +
        (this.isShippingFee ? this.shippingFee : 0)
      );
    }
  },
  watch: {
    useCulturePoint(newVal) {
      this.culturePointUsage = newVal;
    }
  },
  data() {
    return {
      culturePointUsage: this.useCulturePoint
    };
  },
  methods: {
    ...mapActions({
      use: "culturePoint/use"
    }),
    updateCulturePointUsage(e) {
      this.use(e);
    }
  },
  mounted() {
    this.culturePointUsage = this.useCulturePoint;
  }
};
</script>

<style lang="scss" scoped>
::v-deep {
  .art-coupon-container {
    background: #cee7e5;

    &.is-disabled {
      filter: grayscale(100);
      opacity: 0.5;
      cursor: default;
      pointer-events: none;
    }

    > .v-input {
      margin: 0 0 0 30px;
      padding-top: 16px;

      .v-input--selection-controls__input + .v-label {
        margin-left: 0;
      }
    }
  }

  .tb-summary {
    color: #444444;
    background-color: #f2f2f2;
    font-weight: bold;

    @media screen and (max-width: 600px) {
      border-top: 1px solid #c4c4c4;
      // border-bottom: 1px solid #C4C4C4;
    }

    .font-weight-bold span {
      font-weight: bold;
    }
  }
}

// xs and sm
@media screen and (max-width: 960px) {
  .rwd-padding {
    padding: 0 16px;
  }
}

// greater than sm
@media only screen and (min-width: 960px) {
  .rwd-padding {
    padding: 0 32px;
  }
}
</style>
